import type { VirtualItem, Virtualizer } from '@tanstack/react-virtual';
import type { Event } from '@casetrace/shared';
import type { TimelineRow } from '../use-case-timeline';
import type { ToggleHighlightHandler } from '../../../hooks/use-toggle-highlight';
import { RowContent } from './timeline-row-content';

interface TimelineVirtualListProps {
  virtualizer: Virtualizer<HTMLDivElement, Element>;
  virtualItems: VirtualItem[];
  rows: TimelineRow[];
  selectedId: string | null;
  expandedEvent: Event | null;
  highlightedEventIds: ReadonlySet<string>;
  canToggleHighlight: boolean;
  onSelect: (event: Event) => void;
  onDeselect: () => void;
  onToggleHighlight: ToggleHighlightHandler;
}

export function TimelineVirtualList({
  virtualizer,
  virtualItems,
  rows,
  selectedId,
  expandedEvent,
  highlightedEventIds,
  canToggleHighlight,
  onSelect,
  onDeselect,
  onToggleHighlight,
}: TimelineVirtualListProps) {
  return (
    <div style={{ height: virtualizer.getTotalSize(), position: 'relative' }}>
      {virtualItems.map((vItem) => {
        const row = rows[vItem.index];
        if (!row) return null;
        return (
          <div
            key={vItem.key}
            data-index={vItem.index}
            ref={virtualizer.measureElement}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              transform: `translateY(${vItem.start}px)`,
            }}
          >
            <RowContent
              row={row}
              selectedId={selectedId}
              expandedEvent={expandedEvent}
              highlightedEventIds={highlightedEventIds}
              canToggleHighlight={canToggleHighlight}
              onSelect={onSelect}
              onDeselect={onDeselect}
              onToggleHighlight={onToggleHighlight}
            />
          </div>
        );
      })}
    </div>
  );
}
